// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2aSNY","add":"add__nQJYn","drop":"drop__AX9Up"};